export const handleImportProcess = async (apiFunction, description) => {
    try {
        const response = await apiFunction();
        console.log('API Response:', response); // 응답 확인

        if (!response.success) {
            console.error('Import failed:', response.error);
            return {
                success: false,
                message: `Failed to import ${description}: ${response.error}`,
                error: response.error
            };
        }

        return {
            success: true,
            message: `Successfully imported ${description}`,
            data: response.data
        };
    } catch (error) {
        console.error(`Error importing ${description}:`, error);
        return {
            success: false,
            message: `Error occurred while importing ${description}`,
            error
        };
    }
};